module.exports = __webpack_public_path__ + "img/business_1_1.0cfa300a.png";